module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/personal-care-woman-banner@2x_0479cc.png";